import alloyEvents, { YouTubePlayer } from '@/siteBuilder/utils/alloyAnalytics/youtubeVideo'
import { VideoPicker as AlliumVideoPicker } from '@telus-uds/components-web'
import { useState } from 'react'
import { renderSpacer } from 'src/siteBuilder/utils/renderSpacer'
import { ContentfulAnalyticsEventType } from 'src/siteBuilder/utils/types/analytics'
import useKoodoAnalyticsEvent from '../../../../hooks/useKoodoAnalyticsEvent'
import { TelusLocale } from '../../../locale'
import { SpacerProps } from '../Spacer/Spacer'

export type Video = {
  title: string
  description: string
  videoId: string
  videoLength?: number
  aspectRatio?: '16:9' | '4:3' | '1:1'
  beginMuted?: boolean
  defaultVolume?: number
  posterSrc?: string
  copy: TelusLocale['language']
  onPlay?: () => void
  onPause?: () => void
  onEnd?: () => void
}

type YouTubePlayerEvent = { target: YouTubePlayer; data: number }

export type VideoPickerProps = {
  frame?: boolean
  videoList: Video[]
  selectedVideo?: Video['videoId']
  spacer?: SpacerProps
  linkAnalyticsEvent?: ContentfulAnalyticsEventType
}

const VideoPicker = ({ frame = false, videoList, selectedVideo, spacer, linkAnalyticsEvent }: VideoPickerProps) => {
  const [isAnalyticsTriggered, setIsAnalyticsTriggered] = useState(false)
  useKoodoAnalyticsEvent(linkAnalyticsEvent, isAnalyticsTriggered)

  const videos = (videoList ?? []).map((video) => {
    const { videoId } = video
    return {
      ...video,
      onPlay: (event: YouTubePlayerEvent) => alloyEvents.play({ videoId, player: event.target }),
      onPause: (event: YouTubePlayerEvent) => alloyEvents.pause({ videoId, player: event.target }),
      onEnd: (event: YouTubePlayerEvent) => alloyEvents.complete({ videoId, player: event.target }),
    }
  })

  return (
    // TODO: @gpeitzner96 fix accessibility issues
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div data-testid="wrapping-videopicker-div" onClick={() => setIsAnalyticsTriggered(true)}>
      {renderSpacer(spacer)}
      <AlliumVideoPicker frame={frame} videoList={videos} selectedVideo={selectedVideo} />
    </div>
  )
}

export default VideoPicker
